import { useContext } from 'react';
import { ActiveContextContext } from '../context/activeContextDefinition';

export const useActiveContext = () => {
  const context = useContext(ActiveContextContext);
  if (context === undefined) {
    throw new Error('useActiveContext must be used within an ActiveContextProvider');
  }
  return context;
};
